import React from 'react'
import Radios from './Radios'
import Select from './Select'
import RadioButton from './RadioButton'


export default (props) => {
  let Component = Select

  const { field, schema } = props

  if (field?.titleMap?.length < 5) {
    Component = Radios
    if (schema?.field_type == 'radio') Component = Radios
    //指定 radioBtn
    if (schema?.field_type == 'radioBtn') Component = RadioButton
  }
  //指定 select
  if (schema?.field_type == 'select') Component = Select

  return <Component {...props} />
}
